import styled from 'styled-components';

import InputComponent from 'components/Input';

export const Container = styled.section`
  position: relative;
`;

export const InputArea = styled.div`
  cursor: pointer;
`;

export const Input = styled(InputComponent)`
  & > div > input {
    cursor: pointer;
  }
`;

export const Arrows = styled.span`
  position: absolute;
  right: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 20px;
  width: 20px;
  background-size: cover;
  background-image: url('/corporate/images/select-arrows.svg');
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  color: ${({ theme }) => theme.customSelect.primary};
`;
